import { TileFontSizeVariant, TileVariant } from './types';

export const TILE_DEFAULT_FONT_SIZE_VARIANT: TileFontSizeVariant = 'SM';
export const TILE_DEFAULT_VARIANT = TileVariant.Primary;
export const ORDERED_TILE_FONT_SIZE_VARIANTS = [
  'SM',
  'MD',
  'LG',
  'XL',
  'XXL',
] as const;
export const TILE_DEFAULT_WIDTH = 230;

export const TILE_WIDTH_ADJUSTMENT_INCREMENT = 1.25;
export const TILE_WIDTH_ADJUSTMENT_DECREMENT = 0.75;
